/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Row } from "antd";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useGetUserProfileQuery } from "../../../../lib/api/endpoints/settings/settingsEndpoints";
import G_Div from "../../Containers/G_Div";
import G_Image from "../../Image/G_Image";
import ProfileBox from "../../ProfileBox";
import RoleBased from "../../RoleBasedAccess";
import { G_Text } from "../../Text";
import DepotSelector from "./DepotSelector";
import NotificationHandler from "./NotificationHandler";
import ReportBugDrawer from "./ReportBugDrawer/index";

/**
 * @since February 2024
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 * @returns {JSX.Element}
 */

const AppHeader = () => {
  const [open, setOpen] = useState(false);
  const { data } = useGetUserProfileQuery();
  const router = useRouter();

  useEffect(() => {
    if (router.query.traceId) setOpen(true);
  }, [router.query.traceId]);

  return (
    <>
      {open && <ReportBugDrawer open={open} setOpen={setOpen} />}

      <Row align="middle" gutter={12} justify="space-between">
        <Col>
          <DepotSelector />
        </Col>

        <Col flex="auto">
          <Row align="middle" justify="space-between">
            <Col className="flex items-center">
              <G_Image src="/icons/ox-white-logo.svg" height={42} width={42} />
            </Col>

            <Col className="flex items-center">
              <Row align="middle" gutter={32}>
                <RoleBased accessLevels={["MANAGE_NOTIFICATIONS"]}>
                  <Col className="flex items-center">
                    <NotificationHandler />
                  </Col>
                </RoleBased>

                <Col>
                  <G_Div
                    className="bg-[#2A3548] rounded-full h-[32px] px-4 cursor-pointer flex items-center gap-4"
                    onClick={() => setOpen(true)}
                  >
                    <G_Image src="/icons/bug.svg" width={16} />
                    <G_Text
                      className="leading-none"
                      color="ox_2_light_blue"
                      dimension="caption"
                      pointer
                    >
                      Report a Bug
                    </G_Text>
                  </G_Div>
                </Col>

                <Col>
                  <ProfileBox
                    user={{
                      names: data?.payload?.names,
                      sub: data?.payload?.email
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AppHeader;
